export const DEPOSIT_ERROR =
  'The deposit value exceeds the amount you approved for the deposit contract to withdraw from your account';

export const DEPOSIT_EXPIRATION = '31536000';

export const ARB_GAS_LIMIT = '300000';
export const GAS_LIMIT = '200000';

export const ZERO_STRING = '0';
